const steps = [
  {
    icon: "ri-search-line",
    title: "先锁焦点",
    desc: "通过实时榜单和热门话题，快速定位此刻最受关注的热点，判断它是否值得你花时间去跟进。",
    tone: "bg-primary-100 text-primary-700",
  },
  {
    icon: "ri-shield-check-line",
    title: "再验信源",
    desc: "吃瓜不传谣，优先采纳权威媒体与官方发布的一手信息，留意事件的源起、进展与最新回应。",
    tone: "bg-accent-100 text-accent-800",
  },
  {
    icon: "ri-chat-smile-line",
    title: "最后回味",
    desc: "把劲爆消息放回更大的背景里看，理性讨论、友善表达，让每一次围观都多一点收获与思考。",
    tone: "bg-secondary-100 text-secondary-900",
  },
];

export default function HomeGuide() {
  return (
    <section className="container-x py-10 md:py-14">
      <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <span className="chip bg-accent-100 text-accent-800 px-3 py-1 text-xs font-bold">
            <i className="ri-book-2-line"></i> 吃瓜小百科
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl">如何像老手一样优雅吃瓜</h2>
          <p className="mt-3 max-w-xl text-sm text-foreground-600">
            新鲜事层出不穷，劲爆消息往往真假难辨。掌握这三步，你就能在铺天盖地的信息里稳住节奏，既不错过热瓜动态，也不被情绪牵着走。
          </p>
          <div className="mt-6 space-y-3">
            {steps.map((s, i) => (
              <div key={s.title} className="card-surface flex items-start gap-4 p-4">
                <span className={`chip ${s.tone} flex h-8 w-8 shrink-0 items-center justify-center rounded-xl p-0 text-base`}>
                  <i className={s.icon}></i>
                </span>
                <div>
                  <h3 className="font-bold"><span className="mr-1 text-primary-600">0{i + 1} ·</span>{s.title}</h3>
                  <p className="mt-1 text-sm text-foreground-600">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="relative overflow-hidden rounded-3xl">
            <img
              src="https://readdy.ai/api/search-image?query=cozy%20flat%20lay%20scene%20of%20a%20smartphone%20showing%20social%20trending%20feeds%20beside%20a%20cup%20of%20coffee%20and%20sunglasses%20on%20a%20warm%20cream%20desk%2C%20casual%20lifestyle%20editorial%20photography&width=800&height=960&seq=home-guide-01&orientation=portrait"
              alt="理性吃瓜小百科 - 看手机刷新鲜事"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/50 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5 text-background-50">
              <p className="text-sm leading-relaxed text-background-100/95">
                “真正成熟的吃瓜人，懂得在热闹里保持清醒，在喧嚣中找到自己的节奏。”
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}